export default __webpack_public_path__ + "static/media/checkoutChecked.e48f18ba.svg";